module.exports = __webpack_public_path__ + "img/support-your-local.d1529007.svg";